const technologies = {
  technologies: {
    header: {
      overline: "CORE TECH STACK",
      titlePrefix: "Powering",
      titleHighlight: "Intelligence",
      subtitle:
        "A robust set of technologies meticulously selected for high-performance AI solutions and scalable web architectures.",
    },
    tabs: {
      all: "All",
      aiData: "AI & Data Science",
      backendCloud: "Backend & Cloud",
      frontendMobile: "Frontend & Mobile",
      languages: "Languages",
      devopsTools: "DevOps & Tools",
    },
    years: {
      one: "year",
      other: "years",
    },
    cta: {
      titlePrefix: "Need a Custom",
      titleHighlight: "Tech Stack?",
      subtitle:
        "I specialize in architecting scalable AI infrastructures tailored to your specific business needs. Let's discuss your technical requirements.",
      button: "Get Technical Consultation",
    },
  },
};

export default technologies;
